import { useEffect } from "react";
import { Row, Col, Spin, Typography } from "antd";
import CustomInput from "../../../components/CustomInput/Input";
import { accNumberRules, ifscRules, nameRules } from "../../../helpers/helpers";
import { useSelector, useDispatch } from "react-redux";
import InputWithButton from "../../../components/CustomInput/InputWithButton";
import { TITLE_TXT } from "../../../constants/constants";
import {
    kycHistory,
    verifyIfsc,
    verifyBank,
    busVerifyIfsc,
    busVerifyBank,
    busKycHistory
} from "../../../redux/slices/EnqMngtKycSlice";
import { LoadingOutlined } from "@ant-design/icons";

const { Text } = Typography;

const KycBank = ({
    kycData,
    accNum,
    accHolderName,
    ifsc,
    orgId,
    form,
    isReview,
    organizationId,
    token,
}) => {
    const dispatch = useDispatch();
    const { loading, kycHistoryData, ifscData, ifscLoading, bankLoading } =
        useSelector((state) => state.enqMngt);
    const isBankVerified =
        kycHistoryData?.kycDetails?.kycBank?.isVerified ||
        kycData?.kycBank?.isVerified;

    useEffect(() => {
        const handleVerifyIfsc = async () => {
            if (ifsc && /^[A-Z]{4}[0][A-Z0-9]{6}$/.test(ifsc) && !isBankVerified) {
                let payload, action;
                if (token) {
                    payload = { ifscCode: ifsc, orgId: organizationId, token }
                    action = busVerifyIfsc
                } else {
                    payload = { ifscCode: ifsc, orgId }
                    action = verifyIfsc
                }
                const res = await dispatch(action(payload));
                if (res.payload.statusCode === 201) {
                    form.setFieldsValue({
                        bankName: res.payload.response.bankName,
                        branchName: res.payload.response.branchName,
                    });
                }
            }
        };
        handleVerifyIfsc();
    }, [ifsc, dispatch, orgId, form, isBankVerified, token, organizationId]);

    const handleVerifyBtnClick = async (type) => {
        let payload, action;
        if (token) {
            payload = {
                accountName: accHolderName,
                accountNumber: accNum,
                ifsc: ifscData.ifscId,
                orgId: organizationId,
                token
            }
            action = busVerifyBank
        } else {
            payload = {
                accountName: accHolderName,
                accountNumber: accNum,
                ifsc: ifscData.ifscId,
                orgId,
            }
            action = verifyBank
        }
        const res = await dispatch(action(payload));
        if (res?.payload?.statusCode === 201) {
            if (token) {
                dispatch(busKycHistory({ orgId: organizationId, token }))
            } else {
                dispatch(kycHistory(orgId));
            }
        }
    };

    return (
        <Spin spinning={loading}>
            <Text className="kyc-subtitle">{TITLE_TXT.BANK_VERIFY}</Text>
            <Row gutter={[24, 0]}>
                <Col xs={24} md={12}>
                    <CustomInput
                        label="IFSC Code"
                        name="ifsc"
                        type="text"
                        isRequired={true}
                        disabled={isReview || isBankVerified}
                        placeholder="Enter IFSC"
                        rules={ifscRules}
                        suffix={ifscLoading && <LoadingOutlined />}
                    />
                </Col>
                <Col xs={24} md={12}>
                    <CustomInput
                        label="Bank Name"
                        name="bankName"
                        type="text"
                        isRequired={true}
                        disabled={isReview || isBankVerified}
                        placeholder="Enter Bank Name"
                    />
                </Col>
                <Col xs={24} md={12}>
                    <CustomInput
                        label="Branch Name"
                        name="branchName"
                        type="text"
                        isRequired={true}
                        disabled={isReview || isBankVerified}
                        placeholder="Enter Branch Name"
                    />
                </Col>
                <Col xs={0} md={12}></Col>
                <Col xs={24} md={12}>
                    <CustomInput
                        label="Account Holder Name"
                        name="accHolderName"
                        type="text"
                        isRequired={true}
                        disabled={isReview || isBankVerified}
                        placeholder="Enter Account Holder Name"
                        rules={nameRules("Account Holder")}
                    />
                </Col>
                <Col xs={24} md={12}>
                    <InputWithButton
                        label="Bank Account Number"
                        name="accNum"
                        type="text"
                        inputMode="numeric"
                        isRequired={true}
                        placeholder="Enter Account Number"
                        rules={accNumberRules}
                        verifyBtn={true}
                        disabled={isReview || isBankVerified}
                        isVerified={isBankVerified}
                        verifyLoading={bankLoading}
                        disableVerify={
                            isReview ||
                            String(accNum || "").length < 8 ||
                            String(accNum || "").length > 18 ||
                            null
                        }
                        handleVerify={() => handleVerifyBtnClick("accNum")}
                    />
                </Col>
            </Row>
        </Spin>
    );
};

export default KycBank;
